import { setOpenDialog } from "../../../redux/slices/userDetailsDialogSlice";
// Function to show dialog if user does not have required information.
// Note: ProfileCompletionGate (router.jsx) already enforces the critical
// checks (firstName, lastName, username, email, verified phone) at the
// app root with a mandatory multi-step dialog.  This popup only fills the
// gap for location/profile-picture, which are nice-to-have, not blockers.
// We intentionally do NOT re-check fields that ProfileCompletionGate
// already handles — doing so would show two overlapping dialogs.
export const showPopup = (user, dispatch) => {
    if (user.role === "User") {
        if (
            !user?.firstName ||
            !user?.lastName ||
            !user?.phoneNumber
        ) {
            dispatch(setOpenDialog(true));
        }
    }
};
